import React from 'react';
interface CTAButtonProps {
  text?: string;
  href?: string;
  className?: string;
  animate?: boolean;
}
export function CTAButton({
  text = 'QUIERO CONSTRUIR MI CRÉDITO',
  href = '#precio',
  className = '',
  animate = false
}: CTAButtonProps) {
  return <div className="flex flex-col items-center w-full" data-id="element-1">
      <a href={href} onClick={e => {
      e.preventDefault();
      if (href.startsWith('#')) {
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      } else {
        const newWindow = window.open(href, '_blank');
        if (!newWindow) {
          window.location.href = href;
        }
      }
    }} className={`
          inline-block bg-green hover:bg-green-hover text-white font-bold cursor-pointer
          text-lg md:text-xl py-4 px-8 rounded-full shadow-lg 
          transform transition-all duration-300 hover:scale-105 text-center w-full sm:w-auto
          ${animate ? 'animate-pulse-slow shadow-[0_0_20px_rgba(16,185,129,0.5)]' : ''}
          ${className}
        `} data-id="element-2">
        {text}
      </a>
      <p className="text-sm mt-3 text-center opacity-80 font-medium" data-id="element-3">
        🔒 Pago seguro y acceso instantáneo en formato PDF para leer en tu
        celular o imprimir.
      </p>
    </div>;
}